import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { ToastProvider } from "./components/Toast";
import {
  installVersionWatcher,
  isStaleChunkError,
  reloadForStaleChunk,
} from "./lib/chunkReload";
import "./styles/index.css";

// Sprint DN : récupération auto après déploiement. Vite émet `vite:preloadError`
// quand un import() dynamique (chunk d'une page lazy) échoue — typiquement parce
// que le hash a changé depuis le dernier déploiement et que l'ancien chunk
// renvoie 404. On recharge pour récupérer le index.html frais (nouveaux chunks).
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  reloadForStaleChunk();
});

// Filet supplémentaire : selon le navigateur, l'échec peut remonter en rejet de
// promesse non géré plutôt que via l'event Vite.
window.addEventListener("unhandledrejection", (event) => {
  if (isStaleChunkError(event.reason)) {
    reloadForStaleChunk();
  }
});

// Sprint DO-1 : mise à jour proactive au retour de focus (cf. chunkReload.ts).
installVersionWatcher();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
